import { useCallback } from 'react';
import { BookingAssessmentForm } from '../providers/booking-assessment.provider';

interface UseStepTransitionProps {
  values: BookingAssessmentForm;
  setFieldValue: <K extends keyof BookingAssessmentForm>(field: K, value: BookingAssessmentForm[K]) => void;
  resetForm: () => void;
}

export const useStepTransition = ({
  values,
  setFieldValue,
  resetForm,
}: UseStepTransitionProps) => {
  
  const clearScheduleData = useCallback(() => {
    setFieldValue("schedule_ids", []);
    setFieldValue("schedule", []);
    setFieldValue("time_ids", []);
    setFieldValue("time", []);
  }, [setFieldValue]);

  const clearPsychologistData = useCallback(() => {
    setFieldValue("psychologist", null);
    setFieldValue("psychologist_id", null);
    clearScheduleData();
  }, [setFieldValue, clearScheduleData]);

  const clearPatientData = useCallback(() => {
    setFieldValue("patient", null);
    setFieldValue("patient_id", null);
  }, [setFieldValue]);

  const handleAssessmentChange = useCallback((assessmentId: number, assessment: any) => {
    clearPsychologistData();
    clearPatientData();
    
    setFieldValue("assessment_id", assessmentId);
    setFieldValue("assessment", assessment);
  }, [setFieldValue, clearPsychologistData, clearPatientData]);

  const clearAssessmentData = useCallback(() => {
    setFieldValue("assessment_id", null);
    setFieldValue("assessment", null);
    clearPsychologistData();
    clearPatientData();
  }, [setFieldValue, clearPsychologistData, clearPatientData]);

  const handlePsychologistChange = useCallback((psychologistId: number, psychologist: any) => {
    clearScheduleData();
    
    setFieldValue("psychologist_id", psychologistId);
    setFieldValue("psychologist", psychologist);
  }, [setFieldValue, clearScheduleData]);

  const handleMethodChange = useCallback((method: "Online" | "Offline") => {
    clearScheduleData();
    
    setFieldValue("type", method);
  }, [setFieldValue, clearScheduleData]);

  return {
    clearScheduleData,
    clearPsychologistData,
    clearPatientData,
    handleAssessmentChange,
    handlePsychologistChange,
    handleMethodChange,
    clearAssessmentData,
  };
};